/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoaderstepthinking3Inputs */

const en_ailoaderstepthinking3 = /** @type {(inputs: Ailoaderstepthinking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking it through`)
};

const de_ailoaderstepthinking3 = /** @type {(inputs: Ailoaderstepthinking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird durchdacht`)
};

/**
* | output |
* | --- |
* | "Thinking it through" |
*
* @param {Ailoaderstepthinking3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoaderstepthinking3 = /** @type {((inputs?: Ailoaderstepthinking3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoaderstepthinking3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoaderstepthinking3(inputs)
	return de_ailoaderstepthinking3(inputs)
});
export { ailoaderstepthinking3 as "aiLoaderStepThinking" }